import React, { useEffect, useState } from 'react';
import { Toast } from '../Elements/Toast/Toast';

type IdleWarningToastProps = {
  open: boolean;
  warningTime: number;
};

export const IdleWarningToast = ({ open, warningTime }: IdleWarningToastProps) => {
  const [secondsRemaining, setSecondsRemaining] = useState(Math.ceil(warningTime / 1000));

  useEffect(() => {
    if (!open) {
      setSecondsRemaining(Math.ceil(warningTime / 1000));
      return;
    }

    const interval = setInterval(() => {
      setSecondsRemaining((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, [open, warningTime]);

  return (
    <Toast
      open={open}
      variant="warning"
      icon="error"
      title="Session Timeout Warning"
      description={`${secondsRemaining} seconds until automatic signout due to inactivity.`}
      fixed
      position="bottom-4 right-4"
    />
  );
};

IdleWarningToast.displayName = 'IdleWarningToast';
